import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import estimatePreviewBitrate from '@/helpers/estimate_preview_bitrate';

const useSettingsStore = defineStore(
  'settings',
  () => {
    const allowControl = ref(false);
    const gridColumns = ref('auto');
    const headerPinned = ref(true);
    const tooltips = ref(true);

    const previewWidth = ref(640);
    const previewQuality = ref('low');
    const previewEncoderType = ref('webp');
    const previewFps = ref(2);
    const previewEncoderQuality = ref(5);

    const audioMonitorMix = ref('LR');

    const monitorWidth = ref(1344);
    const monitorQuality = ref('medium');
    const monitorEncoderType = ref('webp');
    const monitorFps = ref(12);
    const monitorEncoderQuality = ref(30);

    const previewBitrate = computed(() =>
      estimatePreviewBitrate({
        encoderType: previewEncoderType,
        encoderQuality: previewEncoderQuality,
        fps: previewFps,
      }),
    );

    const monitorBitrate = computed(() =>
      estimatePreviewBitrate({
        encoderType: monitorEncoderType,
        encoderQuality: monitorEncoderQuality,
        fps: monitorFps,
      }),
    );

    return {
      allowControl,
      gridColumns,
      headerPinned,
      tooltips,

      previewWidth,
      previewQuality,
      previewEncoderType,

      previewFps,
      previewEncoderQuality,
      previewBitrate,

      audioMonitorMix,

      monitorWidth,
      monitorQuality,
      monitorEncoderType,

      monitorFps,
      monitorEncoderQuality,
      monitorBitrate,
    };
  },
  {
    persist: { debug: true },
  },
);

export default useSettingsStore;
